var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M314.67 632C86.67 530.67 84 169.33 84 154.67C84 148 89.33 141.33 96 141.33C270.67 126.67 306.67 21.33 308 16C309.33 10.67 314.67 6.67 321.33 6.67C321.33 6.67 321.33 6.67 321.33 6.67C326.67 6.67 332 10.67 334.67 16C336 20 370.67 126.67 546.67 141.33C553.33 141.33 558.67 148 558.67 154.67C558.67 170.67 556 532 328 632C324 633.33 321.33 633.33 320 633.33C318.67 633.33 316 633.33 314.67 632ZM320 605.33C505.33 518.67 526.67 229.33 529.33 166.67C398.67 152 342.67 88 320 50.67C297.33 88 241.33 152 110.67 166.67C113.33 229.33 134.67 518.67 320 605.33Z",
    id: "h3KRuEqXN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.33 453.33C221.33 445.33 226.67 440 234.67 440C242.67 440 248 445.33 248 453.33C248 469.33 261.33 482.67 277.33 482.67C293.33 482.67 306.67 469.33 306.67 453.33C306.67 436.4 306.67 300.93 306.67 284C306.67 276 312 270.67 320 270.67C328 270.67 333.33 276 333.33 284C333.33 300.93 333.33 436.4 333.33 453.33C333.33 484 308 509.33 277.33 509.33C246.67 509.33 221.33 484 221.33 453.33Z",
    id: "cLBatLkaj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.67 165.33C306.67 163.2 306.67 146.13 306.67 144C306.67 136 312 130.67 320 130.67C328 130.67 333.33 136 333.33 144C333.33 146.13 333.33 163.2 333.33 165.33C333.33 172 328 178.67 320 178.67C312 178.67 306.67 173.33 306.67 165.33Z",
    id: "a2S5tnZAUN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.67 328.79C362 328.79 356.67 324.79 355.33 318.12C352.67 300.79 338 288.79 320.67 288.79C303.33 288.79 288.67 300.79 286 318.12C284.67 324.79 279.33 328.79 272.67 328.79C272.53 328.79 271.47 328.79 271.33 328.79C264.67 328.79 259.33 324.79 258 318.12C255.33 300.79 240.67 288.79 223.33 288.79C211.33 288.79 200.67 295.46 194 304.79C190 310.12 184.67 312.79 178 310.12C172.67 307.46 168.67 302.12 168.67 295.46C178 219.46 243.33 160.79 320.67 160.79C396.67 160.79 462 216.79 472.67 292.79C472.67 294.12 474 295.46 474 296.79C474 304.79 468.67 310.12 460.67 310.12C460.67 310.12 460.67 310.12 460.67 310.12C456.67 310.12 451.33 307.46 450 303.46C443.33 292.79 432.67 287.46 420.67 287.46C403.33 287.46 388.67 299.46 386 316.79C382 324.79 376.67 328.79 370 328.79C369.73 328.79 368.8 328.79 368.67 328.79ZM370 286.12C382 271.46 399.33 262.12 419.33 262.12C426 262.12 431.33 263.46 438 264.79C418 219.46 372.67 188.79 322 188.79C271.33 188.79 226 219.46 206 264.79C211.33 263.46 218 262.12 224.67 262.12C244.67 262.12 262 271.46 274 286.12C283.33 271.46 300.67 262.12 320.67 262.12C340.67 262.12 358 271.46 370 286.12Z",
    id: "bcbb2tWHJ"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h3KRuEqXN",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h3KRuEqXN",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cLBatLkaj",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cLBatLkaj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2S5tnZAUN",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2S5tnZAUN",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bcbb2tWHJ",
    opacity: 1,
    fill: "#00af06",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bcbb2tWHJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon4);
export default __webpack_public_path__ + "static/media/info-icon-4.d0d191452f8c3cbee9ca33eda9d7b559.svg";
export { ForwardRef as ReactComponent };